import { z } from "zod";

export function zBlankable<T extends z.ZodType>(schema: T) {
  return z
    .union([schema, z.literal("")])
    .transform((value) => (value === "" ? undefined : value));
}

export const zRequiredEmail = z.email("Enter a valid email");

export const zOptionalEmail = zBlankable(zRequiredEmail);

export const zOptionalSsn = zBlankable(
  z.string().regex(/^\d{9}$/, "SSN must be 9 digits"),
);

export const zRequiredPhone = z
  .string()
  .regex(/^\d{10,11}$/, "Phone number must be 10 or 11 digits");

export const zOptionalPhone = zBlankable(zRequiredPhone);

export const zOtp = z.string().regex(/^\d{6}$/, "Enter a 6-digit code");

export const zOptionalText = z
  .string()
  .optional()
  .transform((value) => value?.trim() || undefined);

export const US_STATE_CODES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
] as const;

export const zUsStateCode = z
  .string()
  .trim()
  .toUpperCase()
  .pipe(
    z.enum(US_STATE_CODES, { error: "Enter a valid two-letter state code" }),
  );

export const zAddress = z.object({
  street: z.string().trim().min(1, "Required"),
  aptNo: zOptionalText,
  city: z.string().trim().min(1, "Required"),
  state: z.string().trim().min(1, "Required"),
  zip: z.string().trim().min(1, "Required"),
  country: z.string(),
});

export const zRealPropertyAddress = z.object({
  street: z.string().trim().min(1, "Required"),
  aptNo: zOptionalText,
  city: z.string().trim().min(1, "Required"),
  state: z.string().trim().min(1, "Required"),
  zip: z.string().trim().min(1, "Required"),
  county: zOptionalText,
});

export const realPropertyAddressDefaultValues: z.input<
  typeof zRealPropertyAddress
> = {
  street: "",
  aptNo: "",
  city: "",
  state: "",
  zip: "",
  county: "",
};
